import NewBrandModal from '@components/NewBrand/NewBrandModal';
import { getUserDisclaimers } from '@lib/api_ts/usersApi';
import { useQuery } from '@tanstack/react-query';

interface AdvModalProps {}

const AdvModal: React.FC<AdvModalProps> = () => {
	const { data: userDisclaimers, isPending: isPendingUserDisclaimers } = useQuery({
		queryKey: ['userDisclaimers'],
		queryFn: getUserDisclaimers,
	});

	const isPending = isPendingUserDisclaimers;

	if (isPending) return <></>;

	const shouldShowNewBrandModal = !userDisclaimers?.includes('new_brand_modal');

	return <>{shouldShowNewBrandModal ? <NewBrandModal /> : null}</>;
};

export default AdvModal;
